import {Component, Input} from '@angular/core';
import {SupportItemDto} from "../../models/support.models";

@Component({
  selector: 'app-contacting-support-item',
  templateUrl: './contacting-support-item.component.html',
  styleUrls: ['./contacting-support-item.component.scss']
})
export class ContactingSupportItemComponent {
  @Input() item: SupportItemDto | undefined
  @Input() selectedId: string | undefined
}
